// Local
const appVersion = require('../package.json').version;
const appSignature= require('../package.json').signature;

const appTitle = "Mitsoft / CGT Bilişim"
const appShortTitle = "Mitsoft [CGTBilisim]"
const appEmail = "iletisim@mitsoft.net"
const appURL = "https://ibonazz.smartback-up.com"

// onLocal
const apiURL_X= "https://api.localhost/api-ibonazz/"
const uploadURL_X = "https://uploads.localhost/ibonazz/"

// onServer
const apiURL= "https://ibonazz.mitdata.com.tr/api/"
const uploadURL = "https://ibonazz.mitdata.com.tr/uploads/"

const dirStokImage = "stokimage/"
const dirAvatar = "avatar/"
const dirIcon = "icon/"
const dirImage = "image/"
//const progressBar = app.appContext.config.globalProperties.$Progress

//const defTOKENTAG="aferinvhyaaseoc"
const defaultRole="visitor";
const defaultCANLogin=0;
const defAUTHUSERTAG="aferinvhyeaseoc"


export default {

    appVersion: appVersion,
    appSignature: appSignature,

    appTitle:appTitle,
    appShortTitle:appShortTitle,
    appEmail:appEmail,
    apiURL:apiURL,
    uploadURL : uploadURL,
    
    dirStokImage: dirStokImage,
    dirAvatar: dirAvatar,
    dirIcon: dirIcon,
    dirImage: dirImage,

    defaultRole:defaultRole,
    defaultCANLogin:defaultCANLogin,
    defAUTHUSERTAG:defAUTHUSERTAG,
}

